var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWomanShrugging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--twemoji",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAC33",
    d: "M19 0c-1.721 0-3.343.406-4.793 1.111A7.064 7.064 0 0 0 13 1a7 7 0 0 0-7 7v12h.018C6.201 26.467 11.489 31.656 18 31.656S29.799 26.467 29.982 20H30v-9c0-6.075-4.925-11-11-11z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9268CA",
    d: "M27 21H9a4 4 0 0 0-4 4v11h26V25a4 4 0 0 0-4-4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDC5D",
    d: "M14 5s-.003 5.308-5 5.936V17c0 4.971 4.029 9 9 9s9-4.029 9-9v-5.019C15.89 11.605 14 5 14 5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#7450A8",
    d: "M10 27h1v9h-1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCAB40",
    d: "M4.702 26.495l-.283-.059h-.511c0-.058.023-.112.035-.169a.994.994 0 0 1-.458-1.048c.112-.542.643-.89 1.186-.779l2.091.433h1.676c.863 0 1.562.7 1.562 1.564V28H6.253s-1.481-.669-1.551-1.505z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDC5D",
    d: "M0 25.655c0-.432.35-.782.781-.782l4.69.782h3.747c.432 0 .781.351.781.781V28H5L.781 26.437S0 26.087 0 25.655z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#9268CA",
    d: "M4 36h6v-8H5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#7450A8",
    d: "M25 27h1v9h-1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCAB40",
    d: "M31.298 26.495l.283-.059h.511c0-.058-.023-.112-.035-.169a.994.994 0 0 0 .458-1.048a1.003 1.003 0 0 0-1.185-.779l-2.091.433h-1.676c-.863 0-1.562.7-1.562 1.564V28h3.747c-.001 0 1.48-.669 1.55-1.505z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDC5D",
    d: "M36 25.655a.782.782 0 0 0-.781-.782l-4.691.782h-3.747a.781.781 0 0 0-.781.781V28h5l4.219-1.563s.781-.35.781-.782z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#9268CA",
    d: "M32 36h-6v-8h5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#BF6952",
    d: "M19 19.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#DF1F32",
    d: "M20.5 23H20a.5.5 0 0 1 0-1h.5a.5.5 0 0 1 0 1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#662113",
    d: "M14 16a1 1 0 0 1-1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1-1 1zm8 0a1 1 0 0 1-1-1v-1a1 1 0 1 1 2 0v1a1 1 0 0 1-1 1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomanShrugging);
export default __webpack_public_path__ + "static/media/woman-shrugging.c5db29b2b465874b6f425b84033944c0.svg";
export { ForwardRef as ReactComponent };